import React, { useEffect, useState } from "react";
const storageIcon = require('../assets/Detasad Cloud/icon_security.svg');
const icon_communication = require('../assets/Detasad Cloud/icon_communication.svg')
const main_icon_highperformance = require('../assets/Detasad Cloud/main_icon_highperformance.svg');
const main_icon_snapshot = require('../assets/Detasad Cloud/main_icon_snapshot.svg');
const availible_ic_zones = require('../assets/Detasad Cloud/availible_ic_zones.svg');
const icon_managedservice = require('../assets/Detasad Cloud/icon_managedservice.svg')  
function Services() {
    const [mobile,setMobile] = useState(false)
    useEffect(()=>{
        if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            setMobile({mobile:true})
        }
    },[])

    return (
        <section className="services-bg pb-3">
            <div className="container">
                <div>
                    <p className={!mobile ? "header-detased text-left":"header-detased"}>Why DETASAD?</p>
                    <p className={!mobile ? " text-left detasad-paragraph" : "detasad-paragraph"}>
                        DETASAD Cloud is a suite of cloud services which includes use of cloud virtual servers, dedicated server, blueprints, network, and application services in a multi-tenant service data center environment.
               </p>
                    <p className={!mobile ? " text-left detasad-paragraph mb-5" : "detasad-paragraph mb-5"}>
                        DETASAD provides the infrastructure including space and power, compute resources, storage resources, virtualization operating system, networking resources and use of the Control portal and API for provisioning and management.
                </p>
                </div>
                <div className={!mobile ? "row text-left" : "row"}>
                    <div className="col-md-4">
                        <div className="service-card">
                            <div className="row">
                                <div className="col-md-4">
                                    <img className="storage-icon" src={storageIcon} alt="" />
                                </div>
                                <div className="col-md-8">
                                    <p className="card-head pt-3">Enterprise Level Security</p>
                                    <p className="card-body">Multi-layer protection for systems & data.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={!mobile ? "col-md-4":"col-md-4 mt-2"}>
                        <div className="service-card">
                            <div className="row">
                                <div className="col-md-4">
                                    <img className="storage-icon" src={main_icon_highperformance} alt="" />
                                </div>
                                <div className="col-md-8">
                                    <p className="card-head pt-3">High Performance</p>
                                    <p className="card-body">Optimized throughout the stack for speed.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={!mobile ? "col-md-4":"col-md-4 mt-2"}>
                        <div className="service-card">
                            <div className="row">
                                <div className="col-md-4">
                                    <img className="storage-icon" src={main_icon_snapshot} alt="" />
                                </div>
                                <div className="col-md-8">
                                    <p className="card-head pt-3">Disaster Recovery</p>
                                    <p className="card-body">Option to build DR in different region</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={!mobile ? "row mt-3 text-left" : "row mt-3"}>
                    <div className={!mobile ? "col-md-4":"col-md-4 mt-2"}>
                        <div className="service-card ">
                            <div className="row">
                                <div className="col-md-4">
                                    <img className="storage-icon" src={availible_ic_zones} alt="" />
                                </div>
                                <div className="col-md-8">
                                    <p className="card-head pt-3">High Availablity</p>
                                    <p className="card-body">Superior uptime with load balancing & redundancy</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={!mobile ? "col-md-4":"col-md-4 mt-2"}>
                        <div className="service-card">
                            <div className="row">
                                <div className="col-md-4">
                                    <img className="storage-icon" src={icon_communication} alt="" />
                                </div>
                                <div className="col-md-8">
                                    <p className="card-head pt-3">Outstanding Support</p>
                                    <p className="card-body">Our support team is standing by 24x7</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={!mobile ? "col-md-4":"col-md-4 mt-2"}>
                        <div className="service-card">
                            <div className="row">
                                <div className="col-md-4">
                                    <img className="storage-icon" src={icon_managedservice} alt="" />
                                </div>
                                <div className="col-md-8">
                                    <p className="card-head pt-3">Managed Services</p>
                                    <p className="card-body">Experts to monitor and manage your apps, 24x7</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}

export default Services;
